
const header = () => {
    let header = document.querySelector('.header');

    function headerClose() {
        if (window.pageYOffset > 20) {
            header?.classList.add('header--close');
        } else {
            header?.classList.remove('header--close');
        }
    }

    headerClose();

    addEventListener("scroll", (event) => {
        headerClose();
    });

    let burger = document.querySelector('.burger');
    let headerMobile = document.querySelector('.header-mobile');
    let mobileNavigationCross = document.querySelector('.mobile-navigation__cross');
    

    burger.addEventListener( "click" , () => {
        headerMobile.classList.add("header-mobile--active");
    })

    mobileNavigationCross.addEventListener( "click" , () => {
        headerMobile.classList.remove("header-mobile--active");
    })
}

export default header;